export const SIGN_IN_REQUEST = 'SIGN_REQUEST';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_FAILURE = 'SIGN_FAILURE';
export const SIGN_OUT = 'SIGN_OUT';
